import './App.css';
import ChatWidget from './components/ChatWidget';

function App() {
  return (
    <div className="App">
      <ChatWidget />
    </div>
  );
}

export default App;
